<div *ngIf="show"
    class="alert d-flex align-items-center justify-content-center text-bold rndc-contingency-alert"
    [ngClass]="alertClass"
    role="alert">
    <i class="fas" [ngClass]="iconClass"></i>
    <span>{{ message }}</span>
</div>
